import Fahrplan from './Fahrplan.vue';
import FahrplanHeader from './FahrplanHeader.vue';
import moduleId from './moduleId';

export const ROUTE_FAHRPLAN = 'ROUTE_FAHRPLAN';
export const ROUTE_FAHRPLAN_DOC = 'ROUTE_FAHRPLAN_DOC';
class FahrdienstRouteHandler {
  getRoutes = ({ moduleType }) => {
    const initiateSyncBeforeNav = true;
    return [
      {
        // entry page -> search for defaults and displays it
        path: '/fahrplan/:instance',
        name: ROUTE_FAHRPLAN,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },

        components: { default: Fahrplan, header: FahrplanHeader },
      },
      {
        path: '/fahrplan/:instance/:documentId', 
        name: ROUTE_FAHRPLAN_DOC,
        meta: { moduleType, moduleId },

        components: { default: Fahrplan, header: FahrplanHeader },
      },

    ];
  };
}
const routeHandler = new FahrdienstRouteHandler();
export default routeHandler;
